import React, { Component } from 'react';

import UserContainer from '../userPanel/UserContainer';
import SearchBar from './SearchBar';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as appSettingsActions from 'state/appSettings/actions';
import './styles/nav.scss';
import DevModeToggler from './DevModeToggler';

class NavContainer extends Component {
  render() {
    return (
      <nav className={`${this.props.showSearchBar ? 'rf-navbar':'rf-navbar rf-navbar-admin'}`}>
        <div className="rf-navbar-left">
          <div className="rf-navbar__logo" />
          {this.props.showSearchBar && <SearchBar />}
        </div>
        <div className="rf-navbar-right">
          {this.props.isDevMode && <DevModeToggler
            isDevModeOn={this.props.isDevModeOn}
            setSettings={this.props.setSettings}
          />
          }
          {this.props.isUserContainer && <UserContainer />}
        </div>
      </nav>
    );
  }
}

NavContainer.propTypes = {
  isDevModeOn: PropTypes.bool.isRequired,
  setSettings: PropTypes.func.isRequired,
  isSearchBar: PropTypes.bool.isRequired,
  isDevMode: PropTypes.bool.isRequired,
  isUserContainer: PropTypes.bool.isRequired
};

NavContainer.defaultProps = {
  isSearchBar: true,
  isDevMode: true,
  isUserContainer: true
};

function mapStateToProps(state) {
  return {
    isDevModeOn: state.appSettings.isDevModeOn
  };
}

const mapDispatchToProps = {
  setSettings: appSettingsActions.setSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavContainer);

